<template>
  <transition name="modal" v-if="viewModal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="cancel">
        <div class="modal-container">
          <div class="modal-header">
            <h3>Choose User</h3>
          </div>
          <div class="modal-body form-horizontal">
            <section>
              <h4>Filters</h4>
              <div class="form-group">
                <label for="username" class="control-label col-sm-3">Username</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="username"
                    class="form-control admin-form-control"
                    type="text" name="username"
                    v-model="usernameSearch"
                    placeholder="Username">
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="checkbox-option">
                <label>
                  <input
                    v-model="adminOnly"
                    type="checkbox"
                    name=""> Search Admin Only Users<br>
                </label>
              </div>
              <div class="clearfix"></div>
            </section>
            <br>
            <br>
            <section>
              <div
                class="form-group">
                <label for="users" class="control-label col-sm-3">Users</label>
                <div class="col-sm-9 input-group">
                  <select id="users" v-model="selectedUser.username" class="form-control admin-form-control">
                    <option value="" disabled selected>--select--</option>
                    <option v-for="(user, index) in users" :key="index" :value="user.username">{{ user.username }}</option>
                  </select>
                </div>
              </div>
              <div class="clearfix"></div>
            </section>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" @click="cancel">Cancel</button>
            <button class="btn admin-btn-primary" @click="view">View</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
  name: 'ViewAsModal',
  props: ['viewModal'],
  data () {
    return {
      adminOnly: false,
      usernameSearch: '',
      selectedUser: {
        username: '',
        bypass: true // TODO: use a process env variable
      }
    }
  },
  computed: {
    ...mapGetters('loyaltyProgram', [ 'programId' ]),
    ...mapState('loyaltyProgram', {
      program: state => state.program
    }),
    users () {
      return this.program.userLoyaltyPrograms
        .filter(ulp => ulp.approved)
        .map(ulp => ulp.user)
        .filter(user => {
          return this.adminOnly ? user.adminOnly : true
        })
        .filter(user => {
          return this.usernameSearch.length > 0 ? user.username.toLowerCase().includes(this.usernameSearch.toLowerCase()) : true
        })
        .sort((user1, user2) => {
          if (user1.username < user2.username) { return -1 }
          if (user1.username > user2.username) { return 1 }
          return 0
        })
    }
  },
  methods: {
    ...mapActions('auth', [
      'logout',
      'login'
    ]),
    ...mapActions('loyaltyProgram', [
      'getLoyaltyProgramBySlug'
    ]),
    view () {
      if (!this.selectedUser.username) {
        return
      }
      this.logout()
        .then(() => {
          return this.login(this.selectedUser)
        })
        .then(() => {
          this.$router.push({ name: 'ClientDashboard', params: { slug: this.program.slug } })
        })
        .catch(err => {
          console.log(err)
        })
    },
    cancel () {
      this.reset()
      this.$emit('close')
    },
    reset () {
      Object.assign(this.$data, this.$options.data())
    }
  }
}
</script>

<style scoped>
.modal-body {
  max-height: 60vh;
  overflow-y: auto;
}

.modal-enter-active, .modal-leave-active {
  transition: opacity .6s;
}
.modal-enter, .modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
